import React from 'react'
import styled from 'styled-components/macro'
import { theme } from 'styled-tools'
import HeaderWrapper from './HeaderWrapper'

const StyledHeader = styled.header`
  background-color: ${theme('color.white')};
`

function Header({ children }) {
  return (
    <StyledHeader>
      <HeaderWrapper>
        {children}
      </HeaderWrapper>
    </StyledHeader>
  )
}

export default Header
